import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { server } from "../server";

// ✅ Fetch all photo requests by userId
export const fetchPhotoRequests = createAsyncThunk(
  "photoRequest/fetchPhotoRequests",
  async (userId) => {
    const token = localStorage.getItem("authToken");
    const response = await fetch(
      `${server}/photoRequest/GetPhotoRequestsByUserId?userId=${userId}`,
      {
        headers: { Authorization: token },
      }
    );
    const data = await response.json();
    return data || [];
  }
);

// ✅ Request a photo
export const requestPhoto = createAsyncThunk(
  "photoRequest/requestPhoto",
  async ({ userId, requestedProfileId }, thunkAPI) => {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`${server}/photoRequest/RequestPhoto`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, requestedProfileId }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error("Failed to request photo");
    }

    await thunkAPI.dispatch(fetchPhotoRequests(userId));
    return null;
  }
);

// ✅ Delete a photo request
export const deletePhotoRequest = createAsyncThunk(
  "photoRequest/deletePhotoRequest",
  async ({ id, userId }, thunkAPI) => {
    const token = localStorage.getItem("authToken");
    const response = await fetch(
      `${server}/photoRequest/DeletePhotoRequest?id=${id}`,
      {
        method: "DELETE",
        headers: { Authorization: token },
      }
    );
    if (!response.ok) throw new Error("Failed to delete photo request");

    // Refresh list after deletion
    await thunkAPI.dispatch(fetchPhotoRequests(userId));
    return id;
  }
);

const photoRequestSlice = createSlice({
  name: "photoRequest",
  initialState: {
    photoRequests: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ✅ Fetch
      .addCase(fetchPhotoRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPhotoRequests.fulfilled, (state, action) => {
        state.photoRequests = action.payload;
        state.loading = false;
      })
      .addCase(fetchPhotoRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // ✅ Request
      .addCase(requestPhoto.pending, (state) => {
        state.error = null;
      })
      .addCase(requestPhoto.rejected, (state, action) => {
        state.error = action.error.message;
      })

      // ✅ Delete
      .addCase(deletePhotoRequest.pending, (state) => {
        state.error = null;
      })
      .addCase(deletePhotoRequest.fulfilled, (state, action) => {
        state.photoRequests = state.photoRequests.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deletePhotoRequest.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export default photoRequestSlice.reducer;
